window.timezone = 'America/Sao_Paulo';
